import React from "react";
import PageWrapper from "../components/PageWrapper";
import Seo from "../components/Seo";
import NewsletterForm from "../sections/newsletter/NewsletterForm";

const NewsletterPage = () => (
  <>
    <Seo
      title="Newsletter — Dioscuro"
      description="One short email, once a month. DevOps notes, lab releases, what we'd build differently."
      pathname="/newsletter"
    />
    <PageWrapper>
      <NewsletterForm />
    </PageWrapper>
  </>
);

export default NewsletterPage;
